/* eslint-disable @typescript-eslint/no-explicit-any */
import { QueryClient } from '@tanstack/react-query'
import { type SearchFeedsQueryVariables } from '../graphql/generated/generated'

const FIVE_MINUTES: number = 300000

export const ACTIVE_FEEDS_QUERY_VARIABLES: SearchFeedsQueryVariables = {
	isActive: true,
	limit: 100,
	lastPaginatedFeedId: null,
}

export const queryClient: QueryClient = new QueryClient( {
	defaultOptions: {
		queries: {
			staleTime: FIVE_MINUTES,
		},
	},
} )
